import React, { useState, useEffect } from 'react';

export default function SummaryBox({selectedClinic, services, people, selectedAppointment}) {

    const [serviceNames, setServiceNames] = useState([]);
    const [address, setAddress] = useState('');
    const [clinic, setClinic] = useState('');
    const [isTravel, setIsTravel] = useState(false);

    const d = new Date(selectedAppointment.date);
    const theDate = ("0" + d.getDate()).slice(-2)+'/'+("0" + (d.getMonth()+1)).slice(-2)+'/'+d.getFullYear();
    const theTime = ("0" + d.getHours()).slice(-2)+':'+("0" + d.getMinutes()).slice(-2);

    useEffect(() => {
        fetch(`/cd/feeds/booking-journey/summary/${selectedClinic}/${services}`)
        .then(response => response.json())
        .then(data => {
            setClinic(data.clinic);
            setAddress(data.address);
            setServiceNames(data.serviceNames);
            setIsTravel(data.isTravel);
        });
    }, []);

    return (
        <div className="content-block-grey">
            <div className="appointment-summary">

                <div className="title-block">
                    <span>Appointment summary</span>
                </div>

                <div className="appointment-summary__wrapper">

                    <div className="appointment-summary__single">
                        <p className="appointment-summary__title">Appointment details</p>
                        <p className="appointment-summary__info">Number of people: <strong>{people}</strong></p>
                        <p className="appointment-summary__info">Date: <strong>{theDate}</strong></p>
                        <p className="appointment-summary__info">Time: <strong>{theTime}</strong></p>
                    </div>

                    {clinic && 
                        <div className="appointment-summary__single">
                            <p className="appointment-summary__title">CityDoc Clinic</p>
                            <p className="appointment-summary__info"><strong>{clinic}</strong></p>
                            <p className="appointment-summary__address" dangerouslySetInnerHTML={{__html:address}}></p>
                        </div>}

                    {serviceNames.length && 
                        <div className="appointment-summary__single">
                            <p className="appointment-summary__title">Services</p>
                            <ul>
                                {serviceNames.map((service, index) => <li key={index}>{service}</li>)}
                            </ul>
                        </div>}

                </div>
                <p className="appointment-summary__footnote">Kindly note that a cancellation made less than 48 hours prior to your booking will incur a fee.</p>
                {isTravel && 
                    <div className="appointment-summary__travel">
                        <div className="title-block"><span>Travel Vaccine Appointment</span></div>
                        <ul className="tick-bullets">
                            <li>Consultation with specialist travel nurse</li>
                            <li>Dispense & administer any vaccinations</li>
                            <li>Assess medical suitability for any vaccinations</li>
                            <li>Advice based on your travel plans</li>
                        </ul>
                        <br /><div className="title-block"><span>Your Travel Vaccines</span></div>
                        <p>During your appointment the nurse will assess your medical and travel details and will only recommend vaccines you need.</p>
                        <ul className="tick-bullets">
                            <li>All vaccines in stock</li>
                        </ul>
                    </div>
                }
            </div>
        </div>
    )
}

